import React, { Component } from "react";
import { render } from "react-dom";
import { connect } from 'react-redux'
import {CallButtonAccept,CallButtonReject,CallButtonMute,ShowInfoDisplay} from '../actions'
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
var contador = 1;


// const optionsToast = {
//     autoClose: false,
//     position: toast.POSITION.BOTTOM_RIGHT,
//     draggable: false,
//     closeOnClick:false,
//     toastId: contador++,
//     containerId:contador
//   };

  const mapStateToProps = (state) => {
    return {
      ContactId: state.atendimento,
    };
  }
  export const CallClientDisconnect = () => {
    if(document.getElementById("reject")!=undefined)
       document.getElementById("reject").click();
  }


  const mapDispatchToProps = dispatch => ({
    ShowInfoDisplay: (post,idnotifier) => {
      dispatch(ShowInfoDisplay(post))
    },
  })

 function AceitarChamada(closeToast,props){
    CallButtonAccept();
    props.ShowInfoDisplay('Clientes')
    closeToast();
 }

 function RejeitarChamada(closeToast){
    CallButtonReject();
    closeToast();
 }

 function muteChamada(closeToast){
  CallButtonMute();
 }

const CustomToastCall = ({closeToast,contato,props}) => {

  //let nomecliente = contato.nomecliente.toString();

 // let nomenumero = (contato.nomecliente!==null || contato.nomecliente!==undefined ) && contato.nomecliente.trim()!=="IMS9300"? contato.nomecliente:contato.cliente;
  let nomenumero = contato.nomecliente!==null && contato.nomecliente!==undefined  && contato.nomecliente!=="IMS9300"? contato.nomecliente:contato.cliente;


  return (
    <div className="calling">
      <div className="calling__text">
        <div className="calling__text__label">Chamador:</div>.
        <div className="calling__text__value">{nomenumero}</div>
      </div>
      <div className="calling__text">
        <div className="calling__text__label">Subserviço:</div>
        <div className="calling__text__value">{contato.mcdu} - {contato.nomesubservico}</div>
      </div>
      <div className="calling__content">
        <button className="calling__content__button calling__content__button--answer" onClick={() => AceitarChamada(closeToast,props)}>
          <i className="material-icons">call</i>
        </button>
        <button className="calling__content__button calling__content__button--mute" onClick={() => muteChamada()}>
          <i className="material-icons">volume_off</i>
        </button>
        <button className="calling__content__button calling__content__button--deny" id="reject" onClick={() => RejeitarChamada(closeToast)}>
          <i className="material-icons">call_end</i>
        </button>
      </div>	
    </div> 
  );
};


class Calling extends Component {

  showCustomToastCall(contato){
        toast(<CustomToastCall contato={contato} props={this.props} containerId={contato.idatendimento}/>,
          {
              autoClose: false,
              position: toast.POSITION.BOTTOM_RIGHT,
              draggable: false,
              closeOnClick:false,
              toastId: contato.idatendimento,
              closeButton: true,
              containerId:contato.idatendimento
          });
    };

  render() {
    const {ContactId} = this.props;

    return (
      <div key={ContactId.idatendimento}>
        {this.showCustomToastCall(ContactId)}
      </div>
    );
  }
}

//export default Calling;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Calling);

